// Fonction utilitaire pour décoder un token JWT
export const decodeJwt = (token: string) => {
	try {
		const base64Url = token.split('.')[1];
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split('')
				.map(
					(c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
				)
				.join('')
		);
		return JSON.parse(jsonPayload);
	} catch (error) {
		console.error('Erreur lors du décodage du token:', error);
		return null;
	}
};

// Fonction pour vérifier l'expiration du token
export const checkTokenExpiration = (token: string) => {
	const decodedToken = decodeJwt(token);
	if (!decodedToken) return null;

	const expirationDate = new Date(decodedToken.exp * 1000);
	const now = new Date();
	const timeUntilExpiration = expirationDate.getTime() - now.getTime();

	return {
		expirationDate,
		isExpired: timeUntilExpiration <= 0,
		timeUntilExpiration
	};
};
